import React, { useEffect, useRef, useState } from "react";
// import { useParams } from "react-router-dom";
// import { MdQueryBuilder } from "react-icons/md";
import { format, formatDistanceToNow } from "date-fns";

import Loader from "../reusble_components/loader";
import {
  AiOutlineCheck,
  AiOutlineClockCircle,
  AiOutlineClose,
  AiOutlineCloseCircle,
  AiOutlineFileText,
} from "react-icons/ai";
import { Observer, useObserver } from "mobx-react";
import { getDomainForWhiteLabeling } from "../../services/white_label";
import { useNavigate, useParams } from "react-router-dom";
import { useStores } from "../../store";
import PdfViewer from "../reusble_components/pdfViewer";
import { toJS } from "mobx";
import HelpCenter from "../reusble_components/helpCenter";
import ReactPaginate from "react-paginate";
import { interviewStatus } from "../../services/reusable";
import { CiLock } from "react-icons/ci";
import OopsImage from "../../assests/oops.png";
import constantVariables from "../../helpers/constantVariables";
import { defaultProfilePic } from "../../helpers/constantVariables";
import { ProgressBarTracker } from "../reusble_components/profileProgress";
import {
  IoIosArrowDropdown,
  IoIosArrowDropright,
  IoIosArrowDropup,
  IoMdCloseCircle,
} from "react-icons/io";
import ReportCard from "../recruiter/report";
import { LiaChevronCircleRightSolid } from "react-icons/lia";
import { RiCheckboxCircleLine } from "react-icons/ri";
import { GoClock } from "react-icons/go";
import { IoSearchOutline } from "react-icons/io5";
import axios from "axios";
import { pdfjs } from "react-pdf";
import AlertPopup from "../signup_2/alertPopup";
import { PopupForUploadResume } from "../recruiter/jobPreview/HR";
import { uploadFileToAzure } from "../../services/azure";
import { LuDot } from "react-icons/lu";
import { MdLocationOn, MdPendingActions } from "react-icons/md";
import { FaUserCheck } from "react-icons/fa";
import { BsCheckCircleFill } from "react-icons/bs";

export function JobPostDetails({ job }) {
  const { CommonStore, PopupStore, RecuiterStore } = useStores();
  const [interview, setInterview] = useState(false);
  const [timer, setTimer] = useState("");
  const [isExpanded, setIsExpanded] = useState(false);
  const [loader, setLoader] = useState(false);
  const applicationsPerPage = 4;
  const [page, setPage] = useState(0);
  const [refresh, setRefresh] = useState(0);
  const [previousRefresh, setPreviousRefresh] = useState(0);
  const skip = page * applicationsPerPage; // Calculate skip dynamically
  const limit = applicationsPerPage;
  const [rejectWhyPopup, setRejectWhyPopup] = useState(false);

  const getResumeScoreColor = (score) => {
    if (score >= 70) return "text-green-500";
    if (score >= 40) return "text-orange-500";
    return "text-red-500";
  };

  useEffect(() => {
    console.log(job, "this is job");
    if (
      job?.jobPostId?.technicalInterview === null &&
      job?.hrInterview !== undefined
    ) {
      setInterview(true);
    } else if (
      job?.jobPostId?.hrInterview === null &&
      job?.technicalInterview !== undefined
    ) {
      setInterview(true);
    } else if (
      job?.technicalInterview !== undefined &&
      job?.hrInterview !== undefined
    ) {
      console.log("in useeffect");

      setInterview(true);
    } else {
      setInterview(false);
    }
    setInterview(interviewStatus(job));
    // const [loader, setLoader] = useState(false);
    const targetTime = new Date(job?.createdAt).getTime() + 72 * 60 * 60 * 1000; // 20 hours in milliseconds
    const interval = setInterval(() => {
      const now = new Date().getTime();
      const distance = targetTime - now;

      // When the count down is over, write some text
      if (distance < 0) {
        clearInterval(interval);
        setTimer("EXPIRED");
      } else {
        // Time calculations for hours, minutes and seconds
        const hours = Math.floor(
          (distance % (1000 * 60 * 60 * 72)) / (1000 * 60 * 60),
        );
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        // Update the timer state
        setTimer(hours + "h " + minutes + "m " + seconds + "s ");
      }
    }, 1000);

    //     job?.jobPostId?.mockTest !== null
    // job?.jobPostId?.technicalInterview !== null
    // job?.jobPostId?.hrInterview !== null

    if (job?.jobPostId?.mockTest !== null) {
      CommonStore.ApplicationProgress[1].hidden = false;
    } else {
      CommonStore.ApplicationProgress[1].hidden = true;
    }
    if (job?.jobPostId?.technicalInterview !== null) {
      CommonStore.ApplicationProgress[2].hidden = false;
    } else {
      CommonStore.ApplicationProgress[2].hidden = true;
    }
    if (job?.jobPostId?.hrInterview !== null) {
      CommonStore.ApplicationProgress[3].hidden = false;
    } else {
      CommonStore.ApplicationProgress[3].hidden = true;
    }

    if (mockTest?._id) {
      CommonStore.ApplicationProgress[1].completed = true;
    } else {
      CommonStore.ApplicationProgress[1].completed = false;
    }
    if (technicalInterview?._id) {
      CommonStore.ApplicationProgress[2].completed = true;
    } else {
      CommonStore.ApplicationProgress[2].completed = false;
    }
    if (hrInterview?._id) {
      CommonStore.ApplicationProgress[3].completed = true;
    } else {
      CommonStore.ApplicationProgress[3].completed = false;
    }
    if (job?.isShortlisted === true) {
      CommonStore.ApplicationProgress[4].completed = true;
    } else {
      CommonStore.ApplicationProgress[4].completed = false;
    }
    if (job?.isHired === true) {
      // alert("hired");
      CommonStore.ApplicationProgress[5].hired = true;
      CommonStore.ApplicationProgress[4].completed = true;
      CommonStore.ApplicationProgress[5].completed = true;
    } else {
      // alert("not hired");
      CommonStore.ApplicationProgress[5].completed = false;
      CommonStore.ApplicationProgress[5].hired = false;
    }
    if (job?.isRejected === true) {
      // alert("hired");
      // CommonStore.ApplicationProgress[5].rejected = true;
      CommonStore.ApplicationProgress[4].rejected = true;
      CommonStore.ApplicationProgress[5].hidden = true;
      CommonStore.ApplicationProgress[5].hired = false;
    } else {
      CommonStore.ApplicationProgress[5].rejected = false;
      CommonStore.ApplicationProgress[5].hidden = false;
      CommonStore.ApplicationProgress[4].rejected = false;
    }
    if (job?.isRejected === true && job?.isShortlisted === true) {
      CommonStore.ApplicationProgress[4].rejected = false;
      CommonStore.ApplicationProgress[5].hidden = false;
      CommonStore.ApplicationProgress[5].rejected = true;
    }
    console.log(
      toJS(CommonStore.ApplicationProgress),
      "this is a common store",
    );

    // Cleanup the interval on component unmount
    return () => clearInterval(interval);
  }, [job]);
  const time = (timeStamp) => {
    const date = new Date(timeStamp);
    return date.toLocaledateString();
  };
  if (!job) {
    return <div>No job selected.</div>;
  }

  const {
    // jobPostId: { jobTitle, jobDescription, recruiterId, pic },
    mockTestStatus,
    technicalInterviewStatus,
    technicalInterview,
    mockTest,
    hrInterview,
    hrInterviewStatus,
    _id,
  } = job;

  const navigateToInterview = (interviewId, applicantId) => {
    const baseUrl = getDomainForWhiteLabeling();
    const url = `https://${baseUrl}/interview-invitation?meetingid=${interviewId}&applicationId=${applicantId}`;

    window.location.href = url;
  };

  const handleClick = () => {
    if (job?.jobPostId?.mockTest !== null && !mockTest) {
      const baseUrl = getDomainForWhiteLabeling();
      const url = `https://${baseUrl}/dashboard/mocktest?mocktestId=${job?.jobPostId?.mockTest}&applicationId=${_id}`;
      console.log(job);
      window.location.href = url;
    } else if (
      job?.jobPostId?.technicalInterview !== null &&
      !technicalInterview
    ) {
      navigateToInterview(job?.jobPostId?.technicalInterview?._id, _id);
    } else if (job?.jobPostId?.hrInterview !== null && !hrInterview) {
      navigateToInterview(job?.jobPostId?.hrInterview?._id, _id);
    } else {
      setInterview(true);
    }
  };
  const reportData = [
    {
      title: "MCQ test report",
      show: job?.jobPostId?.mockTest !== null,
      commingFrom: "userSide",
      mcq: true,
      score: job?.mockTest?.categoryWiseReport?.overall?.accuracy ?? null,
      videoData: null,
      details: [
        {
          label: "Assessment Name:",
          value: job?.jobPostId?.mockTest?.mockTestName,
        },
        {
          label: "Cut off :",
          value: job?.jobPostId?.mockTest?.cutOff,
        },
        {
          label: "Number of questions:",
          value: `${job?.mockTest?.categoryWiseReport?.overall?.correct ?? 0}/${
            job?.mockTest?.categoryWiseReport?.overall?.total ?? 0
          }`,
        },
        {
          label: "Status:",
          value:
            (job?.jobPostId?.mockTest?.cutOff ?? 0) >
            (job?.mockTest?.categoryWiseReport?.overall?.accuracy ?? 0)
              ? "Failed"
              : "Qualified",
        },
      ],
      showCheckDetails: job?.mockTest !== undefined,
      reportId: job?.mockTest?._id,
      hasFailed:
        (job?.jobPostId?.mockTest?.cutOff ?? 0) >
        (job?.mockTest?.categoryWiseReport?.overall?.accuracy ?? 0),
    },
    {
      title: "Technical Interview Report",
      video: true,
      show: job?.jobPostId?.technicalInterview !== null,
      commingFrom: "userSide",
      score: job?.technicalInterview?.result?.[0]?.score ?? null,
      videoData: {
        videoSrc: job?.technicalInterview?.recording ?? "",
        onDownload: () => console.log("Downloading video 1"),
        title: "Technical Interview",
      },
      details: [
        {
          label: "Type of interview:",
          value: job?.technicalInterview?.interviewType,
        },
        {
          label: "Cut off :",
          value: job?.jobPostId?.technicalInterview?.cutOff ?? 0,
        },
        {
          label: "Number of questions:",
          value: job?.technicalInterview?.noOfQuestions ?? 0,
        },
        {
          label: "Status:",
          value:
            job?.jobPostId?.technicalInterview?.cutOff >
            job?.technicalInterview?.result[0]?.score
              ? "Failed"
              : "Qualified",
        },
      ],
      questions: job?.technicalInterview?.questions,
      showCheckDetails: job?.technicalInterview !== undefined,
      reportId: job?.technicalInterview?._id,
      hasFailed:
        (job?.jobPostId?.technicalInterview?.cutOff ?? 0) >
        (job?.technicalInterview?.result?.[0]?.score ?? 0),
    },
    {
      hr: true,
      title: "HR Interview Report",
      show: job?.jobPostId?.hrInterview !== null,
      commingFrom: "userSide",
      video: true,
      score: job?.hrInterview?.result?.[0]?.score ?? null,
      videoData: {
        videoSrc: job?.hrInterview?.recording ?? "",
        onDownload: () => console.log("Downloading video 2"),
        title: "HR Interview",
      },
      details: [
        {
          label: "Interview name:",
          value: job?.hrInterview?.technology,
        },
        {
          label: "Cut off :",
          value: job?.jobPostId?.hrInterview?.cutOff ?? 0,
        },
        {
          label: "Number of questions:",
          value: job?.technicalInterview?.noOfQuestions ?? 0,
        },
        {
          label: "Status:",
          value:
            job?.jobPostId?.hrInterview?.cutOff >
            job?.hrInterview?.result[0]?.score
              ? "Failed"
              : "Qualified",
        },
      ],
      questions: job?.hrInterview?.questions,
      showCheckDetails: job?.hrInterview !== undefined,
      reportId: job?.hrInterview?._id,
      hasFailed:
        (job?.jobPostId?.hrInterview?.cutOff ?? 0) >
        (job?.hrInterview?.result?.[0]?.score ?? 0),
    },
  ];

  // Check if any test has failed
  const anyTestFailed = true;

  const steps = [
    { label: "Applied", completed: true, label2: "Applied", show: true },
    {
      label: "MCQ's",
      completed: reportData[0].showCheckDetails,
      label2: "MCQ's",
      show: reportData[0].show,
    },
    {
      label: "Technical Interview",
      completed: reportData[1].showCheckDetails,
      label2: "Technical",
      show: reportData[1].show,
    },
    {
      label: "HR Intreview",
      completed: reportData[2].showCheckDetails,
      label2: "HR",
      show: reportData[2].show,
    },
  ];

  // console.log(reportData[0], "this is report data");
  let rejectedInserted = false;

  // Check if MCQ test is completed and score is below cutoff
  if (
    reportData[0].show &&
    job?.jobPostId?.mockTest?.cutOff > reportData[0].score &&
    !rejectedInserted &&
    steps[1].completed // Ensure MCQ step (Applied) is completed before proceeding
  ) {
    steps.splice(2, 0, {
      label: "Rejected",
      rejected: true,
      label2: "Rejected",
      show: true,
    });
    rejectedInserted = true;
  }

  // Check if Technical Interview is completed and score is below cutoff
  if (
    reportData[1].show &&
    job?.jobPostId?.technicalInterview?.cutOff > reportData[1].score &&
    !rejectedInserted &&
    steps[2].completed // Ensure Technical Interview is completed before proceeding
  ) {
    steps.splice(3, 0, {
      label: "Rejected",
      rejected: true,
      label2: "Rejected",
      show: true,
    });
    rejectedInserted = true;
  }

  // Check if HR Interview is completed and score is below cutoff
  if (
    reportData[2].show &&
    job?.jobPostId?.hrInterview?.cutOff > reportData[2].score &&
    !rejectedInserted &&
    steps[3].completed // Ensure HR Interview is completed before proceeding
  ) {
    steps.splice(4, 0, {
      label: "Rejected",
      rejected: true,
      label2: " Rejected",
      show: true,
    });
    rejectedInserted = true;
  }

  // Check if resume score is below cutoff
  if (
    job?.resumeScore < job?.jobPostId?.resumeCutoffScore &&
    !rejectedInserted &&
    steps[0].completed // Ensure Applied step is completed before proceeding
  ) {
    steps.splice(1, 0, {
      label: "Rejected",
      rejected: true,
      label2: "Rejected",
      show: true,
    });
    rejectedInserted = true;
  }

  const fetchData = async (pdfFile) => {
    try {
      const response = await axios.get(pdfFile, {
        responseType: "arraybuffer",
      });

      const pdfData = response.data;
      const pdf = await pdfjs.getDocument({ data: pdfData }).promise;
      let fullText = "";

      for (let i = 1; i <= pdf.numPages; i++) {
        const page = await pdf.getPage(i);
        const content = await page.getTextContent();
        const pageText = content.items.map((item) => item.str).join("\n");
        fullText += pageText + "\n";
      }

      return fullText; // Return fullText from the function
    } catch (error) {
      console.error("Error fetching or parsing PDF file", error);
      return null; // Return null in case of an error
    }
  };

  const GenerateResumeScore = async () => {
    console.log("GenerateResumeScore");
    console.log(loader);
    console.log("this is Resume", job?.resume);

    const resumeText = await fetchData(job?.resume);

    if (!resumeText) {
      alert(
        "The resume Uploaded by the candidate is not in a readable format. ",
      );
      setLoader(false);
      return;
    }

    RecuiterStore.fetchResumeScoreAPI(job?._id, resumeText).then(() => {
      console.log(loader);
      if (job) {
        job.resumeScore = RecuiterStore.resumeScoreDataCount;
      }
      setLoader(false);
      console.log(loader);
    });
  };

  return (
    <div className="pb-4 relative w-full md:mt-0 mx-auto h-full overflow-y-auto">
      <Loader loader={loader} />

      <InterviewDetailsPopup job={job} />
      {rejectWhyPopup && <AlertPopup />}

      <div className=" md:pr-6 mpx-2 w-full">
        <div className="hidden md:block">
          <div className="w-full  flex justify-between mx-auto border bg-black md:mb-2 rounded-lg  pt-5 mt-2 items-center !text-white p-8 ">
            <div className="md:w-[70%]">
              <ProgressBarTracker
                steps={steps}
                onRejectClickWhy={() => {
                  setRejectWhyPopup(true);
                  PopupStore.setAlert(true);
                  PopupStore.setTitle("Reason for rejection");
                  PopupStore.setMessage(`
                  The Required cut off for this assessment is not met by the candidate.
                  
                `);
                }}
                commingFrom={"history"}
              />
            </div>

            {
              // if every step is completed or rejectInjected is true then dont show this
              steps.every((step) => step.completed) || !rejectedInserted ? (
                <div className=" mt-3">
                  <button
                    className={`${
                      rejectedInserted
                        ? "bg-red-500"
                        : job?.hrInterview
                          ? "bg-green-500"
                          : job?.jobPostId?.isOpen
                            ? "bg-primary"
                            : "bg-red-500 cursor-not-allowed"
                    } rounded-lg md:rounded-xl py-2 whitespace-nowrap px-2 text-sm md:px-4 md:py-2 flex items-center gap-1  md:gap-2 text-white`}
                    onClick={() => {
                      !rejectedInserted
                        ? job?.jobPostId?.isOpen
                          ? PopupStore.setInterviewDetails(true)
                          : alert("Assessment Closed...")
                        : alert("Assessment Cancelled");
                    }}
                  >
                    {" "}
                    {}
                    {!rejectedInserted
                      ? `${
                          job?.hrInterview
                            ? "Assessment done"
                            : job?.jobPostId?.isOpen
                              ? "Complete Assessment"
                              : "Assessment Closed"
                        }`
                      : "Assessment Cancelled"}
                    {!rejectedInserted && job?.jobPostId?.isOpen && (
                      <IoIosArrowDropright className="text-white" />
                    )}
                  </button>
                </div>
              ) : null
            }
          </div>
        </div>
        <div
          className={
            "w-full  flex flex-col justify-between  mx-auto border border-primary bg-white rounded-lg  pt-2 items-center  md:hidden   !text-black pr-3 " +
            " md:pb-5 lg:pb-5 pb-10 "
          }
        >
          <ProgressBarTracker steps={steps} commingFrom={"applicant"} />
        </div>

        <div className="flex justify-between items-start w-full lg:px-5 md:px-5 py-3 px-2 md:py-3 bg-[#E9E9E9] rounded-t-lg">
          <div className="flex items-start flex-col w-full md:flex-row">
            <div className="flex w-full">
              <img
                src={job?.recruiter?.pic ?? constantVariables.defaultProfilePic}
                alt={job?.jobPostId?.recruiterId?.companyName || "Company"}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = constantVariables.defaultProfilePic;
                }}
                className="w-[80px] h-[80px] mr-4 object-cover rounded-lg"
              />
              <div className="w-full">
                <div className="flex items-start justify-between w-full">
                  <h2 className="text-sm md:text-lg font-bold text-primary">
                    {job?.jobPostId?.jobTitle}
                  </h2>
                  <div className="ml-4 md:ml-0">
                    <p className="font-semibold text-sm flex items-center gap-2">
                      Status:{" "}
                      <span
                        className={`border font-normal text-white rounded-md text-xs py-1 px-3 ${
                          job?.status === 0
                            ? "bg-yellow"
                            : job?.status === 1
                              ? "bg-blue-500"
                              : job?.status === 2
                                ? "bg-red-500"
                                : job?.status === 3
                                  ? "bg-green-500"
                                  : "bg-gray-500"
                        }`}
                      >
                        {job?.status === 0
                          ? "Pending"
                          : job?.status === 1
                            ? "Shortlisted"
                            : job?.status === 2
                              ? "Rejected"
                              : job?.status === 3
                                ? "Hired"
                                : ""}
                      </span>
                    </p>
                  </div>
                </div>

                <p className="text-xs text-gray-600 mt-1">
                  {job?.recruiter?.companyName}
                </p>

                <div className="flex md:w-[60%] mt-3">
                  <div className="hidden md:block border-primary w-full">
                    <div className="grid grid-cols-3 gap-4 text-gray-600">
                      <p className="text-sm px-2 border-l-2 border-primary">
                        No of Applied:{" "}
                        {job?.jobPostId?.applications.length ?? 0}
                      </p>
                      <p className="text-sm px-2 border-l-2 border-primary">
                        Shortlisted: {job?.jobPostId?.shortListed.length ?? 0}
                      </p>
                      <p className="text-sm px-2 border-l-2 border-primary">
                        Rejected: {job?.jobPostId?.rejected.length ?? 0}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="hidden md:block">
                  <div className="flex flex-wrap gap-3 mt-4">
                    <span className="bg-[#D4D4D4] text-sm px-4 py-1.5 rounded-full">
                      {job?.jobPostId?.salary?.minimum &&
                      job?.jobPostId?.salary?.maximum ? (
                        <>
                          ₹{" "}
                          {job?.jobPostId?.salary?.minimum >= 100000
                            ? `${job?.jobPostId?.salary?.minimum / 100000}L`
                            : job?.jobPostId?.salary?.minimum}{" "}
                          - ₹{" "}
                          {job?.jobPostId?.salary?.maximum >= 100000
                            ? `${job?.jobPostId?.salary?.maximum / 100000}L`
                            : job?.jobPostId?.salary?.maximum}{" "}
                        </>
                      ) : (
                        <p>₹ Not Disclosed</p>
                      )}
                    </span>
                    <span className="bg-[#D4D4D4] text-sm px-4 py-1.5 rounded-full">
                      {job?.jobPostId?.jobMode}
                    </span>
                    <span className="bg-[#D4D4D4] text-sm px-4 py-1.5 rounded-full">
                      {job?.jobPostId?.jobLocation}
                    </span>
                    <span className="bg-[#D4D4D4] text-sm px-4 py-1.5 rounded-full">
                      {job?.jobPostId?.workMode}
                    </span>
                    <span className="bg-[#D4D4D4] text-sm px-4 py-1.5 rounded-full">
                      {job?.jobPostId?.noOfOpenings} Openings
                    </span>
                    <span className="bg-[#D4D4D4] text-sm px-4 py-1.5 rounded-full">
                      {job?.jobPostId?.requiredExperience.minimum}-{" "}
                      {job?.jobPostId?.requiredExperience.maximum} Years
                      Experience
                    </span>
                  </div>
                </div>

                <div className="hidden md:flex justify-between items-center mt-4">
                  <div className="flex items-center gap-4">
                    <button
                      className="flex items-center gap-1 text-primary hover:underline text-sm font-medium"
                      onClick={() => {
                        CommonStore.setResume(true);
                        CommonStore.setJobResume(job.resume);
                        RecuiterStore.setAllowError(true);
                      }}
                    >
                      <AiOutlineFileText className="text-lg" />
                      Resume
                    </button>

                    <div className="flex items-center gap-2">
                      {job?.resumeScore ? (
                        <p
                          className={`${getResumeScoreColor(
                            job.resumeScore,
                          )} font-medium text-sm`}
                        >
                          {job.resumeScore}% Matched
                        </p>
                      ) : (
                        <div className="flex items-center gap-2">
                          <span className="text-gray-500">- - %</span>
                          <button
                            className="text-primary hover:underline text-sm font-medium"
                            onClick={() => {
                              setLoader(true);
                              GenerateResumeScore();
                            }}
                          >
                            Get Score
                          </button>
                        </div>
                      )}
                    </div>
                  </div>

                  <button
                    onClick={() => setIsExpanded(!isExpanded)}
                    className="text-primary text-sm hover:underline flex items-center gap-1"
                  >
                    {isExpanded ? "View Less" : "View More"}
                    {isExpanded ? (
                      <IoIosArrowDropdown className="text-lg" />
                    ) : (
                      <IoIosArrowDropright className="text-lg" />
                    )}
                  </button>
                </div>
              </div>
            </div>

            <div className="pt-3 block md:hidden w-full">
              <div className="grid grid-cols-3 gap-2 text-gray-600">
                <p className="text-sm px-2 border-l-2 border-primary">
                  Applied: {job?.jobPostId?.applicantsCount ?? 0}
                </p>
                <p className="text-sm px-2 border-l-2 border-primary">
                  Shortlisted: {job?.jobPostId?.shortListed.length ?? 0}
                </p>
                <p className="text-sm px-2 border-l-2 border-primary">
                  Rejected: {job?.jobPostId?.rejected.length ?? 0}
                </p>
              </div>
            </div>

            <div className="block md:hidden mt-3">
              <div className="flex flex-wrap gap-2">
                <span className="bg-[#D4D4D4] text-xs px-3 py-1 rounded-full">
                  {job?.jobPostId?.salary?.minimum &&
                  job?.jobPostId?.salary?.maximum ? (
                    <>
                      ₹{" "}
                      {job?.jobPostId?.salary?.minimum >= 100000
                        ? `${job?.jobPostId?.salary?.minimum / 100000}L`
                        : job?.jobPostId?.salary?.minimum}{" "}
                      - ₹{" "}
                      {job?.jobPostId?.salary?.maximum >= 100000
                        ? `${job?.jobPostId?.salary?.maximum / 100000}L`
                        : job?.jobPostId?.salary?.maximum}
                    </>
                  ) : (
                    "₹ Not Disclosed"
                  )}
                </span>
                <span className="bg-[#D4D4D4] text-xs px-3 py-1 rounded-full">
                  {job?.jobPostId?.jobMode}
                </span>
                <span className="bg-[#D4D4D4] text-xs px-3 py-1 rounded-full">
                  {job?.jobPostId?.jobLocation}
                </span>
                <span className="bg-[#D4D4D4] text-xs px-3 py-1 rounded-full">
                  {job?.jobPostId?.workMode}
                </span>
                <span className="bg-[#D4D4D4] text-xs px-3 py-1 rounded-full">
                  {job?.jobPostId?.noOfOpenings} Openings
                </span>
                <span className="bg-[#D4D4D4] text-xs px-3 py-1 rounded-full">
                  {job?.jobPostId?.requiredExperience.minimum}-
                  {job?.jobPostId?.requiredExperience.maximum} Years
                </span>
              </div>

              <div className="flex justify-between items-center mt-4">
                <div className="flex items-center gap-2">
                  <button
                    className="flex items-center gap-1 text-primary text-sm"
                    onClick={() => {
                      CommonStore.setResume(true);
                      CommonStore.setJobResume(job.resume);
                      RecuiterStore.setAllowError(true);
                    }}
                  >
                    <AiOutlineFileText />
                    Resume
                  </button>
                  {job?.resumeScore ? (
                    <p
                      className={`${getResumeScoreColor(
                        job.resumeScore,
                      )} text-sm`}
                    >
                      {job.resumeScore}% Matched
                    </p>
                  ) : (
                    <div className="flex items-center gap-2">
                      <span className="text-gray-500 text-sm">- - %</span>
                      <button
                        className="text-primary text-sm"
                        onClick={() => {
                          setLoader(true);
                          GenerateResumeScore();
                        }}
                      >
                        Get Score
                      </button>
                    </div>
                  )}
                </div>

                <button
                  onClick={() => setIsExpanded(!isExpanded)}
                  className="text-primary text-sm flex items-center"
                >
                  {isExpanded ? "View Less" : "View More"}
                  {isExpanded ? (
                    <IoIosArrowDropdown />
                  ) : (
                    <IoIosArrowDropright />
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>

        {isExpanded && (
          <div className="bg-white rounded-b-lg shadow-r-lg">
            <div className="p-4 md:p-6 space-y-6">
              <div>
                <h1 className="font-bold text-lg mb-2">Job Description</h1>
                <p className="text-[#747474] leading-relaxed">
                  {job?.jobPostId?.jobDescription}
                </p>
              </div>

              <div>
                <h1 className="font-bold text-lg mb-2">Required Skills</h1>
                <div className="flex flex-wrap gap-2">
                  {job?.jobPostId?.requiredSkills.map((skill, index) => (
                    <span
                      key={index}
                      className="bg-[#D4D4D4] text-sm px-4 py-1.5 rounded-full text-[#747474]"
                    >
                      {skill}
                    </span>
                  ))}
                </div>
              </div>

              <div className=" md:pr-6 mpx-2 w-full justify-between items-center">
                <p className="text-sm px-2 border-l-2 border-primary">
                  Mode of work:{" "}
                  {job?.jobPostId?.workMode === "workFromOffice"
                    ? "WORK FROM OFFICE"
                    : job?.jobPostId?.workMode}
                </p>
                <p className="text-sm px-2 border-l-2 border-primary">
                  No. of openings: {job?.jobPostId?.noOfOpenings}
                </p>
                <p className="text-sm px-2 border-l-2 border-primary">
                  Work type: {job?.jobPostId?.jobMode}
                </p>
              </div>
              {/* <div className="flex justify-end pt-2">
              <button
                onClick={() => setIsExpanded(!isExpanded)}
                className="text-primary text-sm hover:underline flex items-center gap-1"
              >
                View Less <IoIosArrowDropdown className="text-lg" />
              </button>
            </div> */}
            </div>
          </div>
        )}
      </div>

      <div className=" md:pr-6 mpx-2 w-full justify-between items-center">
        {reportData.map(
          (report, index) =>
            report.show && (
              <ReportCard
                key={index}
                {...report}
                anyTestFailed={anyTestFailed}
                commingFrom="userSide"
                handleButtonClick={() => PopupStore.setInterviewDetails(true)}
              />
            ),
        )}
      </div>
    </div>
  );
}

export function InterviewDetailsPopup({ job }) {
  const { PopupStore } = useStores();

  const closeThisPopUP = () => {
    PopupStore.setInterviewDetails(false);
  };

  return useObserver(() => {
    return (
      <>
        {PopupStore.inverviewdetails && (
          <div
            onClick={() => closeThisPopUP}
            className="fixed w-screen h-screen z-50 inset-0 backdrop-filter backdrop-blur-sm bg-black bg-opacity-40"
          >
            <div
              onClick={(e) => e.stopPropagation()}
              className="absolute  inset-0 bg-bg3 z-50 flex flex-col justify-center rounded-xl items-center md:w-[35%] lg:w-[30%] w-[90%] h-[75%] md:h-fit lg:h-fit m-auto shadow-lg overflow-y-auto no-scrollbar"
            >
              <div className="flex flex-col gap-6 justify-start items-start p-6  h-full py-5 w-[100%] md:w-[100%] lg:[100%] border ">
                <AiOutlineCloseCircle
                  className="absolute text-xl cursor-pointer text-primaryF top-2 right-2"
                  onClick={closeThisPopUP}
                />
                <InterviewDetails job={job}></InterviewDetails>
              </div>
            </div>
          </div>
        )}
      </>
    );
  });
}

export function InterviewDetails({ job }) {
  const { MockStore } = useStores();
  const navigate = useNavigate();
  const [showHRError, setShowHRError] = useState(false);

  const {
    jobPostId,
    technicalInterviewStatus,
    hrInterviewStatus,
    technicalInterview,
    mockTest,
    hrInterview,
    _id,
  } = job;
  const technicalInterviewPending = technicalInterviewStatus === "pending";
  const technicalInterviewCompleted = technicalInterviewStatus === "completed";
  const hrInterviewPending = hrInterviewStatus === "pending";
  const hrInterviewCompleted = hrInterviewStatus === "completed";

  let buttonText = "Complete interview";
  if (technicalInterviewPending && hrInterviewPending) {
    buttonText = "Take the interviews";
  } else if (technicalInterviewCompleted && hrInterviewPending) {
    buttonText = "Complete the HR Interview";
  }

  const navigateToInterview = (interviewId, applicantId) => {
    localStorage.setItem("location", window.location.pathname);
    const baseUrl = getDomainForWhiteLabeling();
    const url = `https://${baseUrl}/interview-invitation?meetingid=${interviewId}&applicationId=${applicantId}`;

    window.location.href = url;
  };
  const navigateToMockTest = (invitationId, applicantId) => {
    // alert("hello");
    const baseUrl = getDomainForWhiteLabeling();
    const url = `${baseUrl === "app.reaidy.io" ? `https://user.reaidy.io/mcq-test/${invitationId}` : `https://${baseUrl}`}/dashboard/mocktest?mocktestId=${invitationId}&applicationId=${applicantId}&recruiterId=${jobPostId?.recruiterId}`;

    window.location.href = url;
  };

  const [isTechincalApplicationOpen, setisTechincalApplicationOpen] =
    useState(false);
  const [isMockApplicationOpen, setisMockApplicationOpen] = useState(false);
  const [isHRApplicationOpen, setisHRApplicationOpen] = useState(false);

  function findDateIscurrentlyOrNot(date) {
    const currentDate = new Date();
    const inputDate = new Date(date);
    return inputDate > currentDate;
  }

  function convertDate(date) {
    // console.log("this is the time stamp for open at ", date);
    const convertedDate = new Date(date);
    const day = String(convertedDate.getDate()).padStart(2, "0"); // Adds leading zero if needed
    const month = String(convertedDate.getMonth() + 1).padStart(2, "0"); // Months are zero-indexed
    const year = convertedDate.getFullYear();
    const hour = String(convertedDate.getHours()).padStart(2, "0"); // Adds leading zero for hour
    const minute = String(convertedDate.getMinutes()).padStart(2, "0"); // Adds leading zero for minutes

    // Format as DD-MM-YYYY HH:MM
    const formattedDate = `${day}-${month}-${year} /${hour}:${minute}`;

    // setIsApplicationOpen(`The Interview will be opened from ${formattedDate}`);
    // console.log("Formatted date:", formattedDate);
    return `The Interview Starts form ${formattedDate}`;
  }

  return useObserver(() => {
    if (!job) {
      return <div>No job selected.</div>;
    }
    return (
      <div className="max-w-3xl mx-auto p-6 bg-white rounded-lg shadow-sm">
        <Loader loader={MockStore.loader} />
        <div className="px-2">
          <h3 className="text-xl font-semibold mb-6 text-primary">
            Assessment Details
          </h3>
          <div className="space-y-6">
            {jobPostId?.mockTest !== null && (
              <div className="border-b border-gray-100 pb-6">
                <div className="flex items-center justify-between mb-4">
                  <p className="text-lg font-semibold">MCQ's</p>
                  <div className="flex flex-col items-end gap-2">
                    <button
                      onClick={() => {
                        const MockTestTime = (jobPostId?.openAt
                          ?.filter((item) => item.label === "mockTest")
                          .map((item) => item.time))[0];
                        if (findDateIscurrentlyOrNot(MockTestTime)) {
                          setisMockApplicationOpen(convertDate(MockTestTime));
                          return alert(convertDate(MockTestTime));
                        }
                        if (!mockTest) {
                          navigateToMockTest(
                            jobPostId?.mockTest?._id,
                            _id,
                            jobPostId?.recruiterId,
                          );
                        }
                      }}
                      className={`inline-flex items-center justify-center px-5 py-2 rounded-lg text-sm font-medium transition-colors ${
                        mockTest
                          ? "bg-green-600 text-white hover:bg-green-700"
                          : "bg-[#fed500] text-white hover:bg-[#e6c000]"
                      }`}
                    >
                      {!mockTest ? "Take the Mock Test" : "Mock Test Completed"}
                    </button>
                    {mockTest && (
                      <button
                        className="text-sm text-primary hover:text-primary/80 font-medium"
                        onClick={async () => {
                          const baseUrl = getDomainForWhiteLabeling();
                          localStorage.setItem(
                            "mockTestId",
                            jobPostId?.mockTest,
                          );
                          if (window.innerWidth < 768) {
                            navigate(`/mockexamreport?id=${mockTest._id}`);
                          } else {
                            navigate(
                              `/dashboard/mockexamreport?id=${mockTest._id}`,
                            );
                          }
                        }}
                      >
                        Check Your Report
                      </button>
                    )}
                  </div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div className="flex flex-col bg-gray-50 p-3 rounded-lg">
                    <span className="text-gray-500 text-sm mb-1">
                      Total questions
                    </span>
                    <span className="text-primary font-medium">
                      {calculateTotalQuestions(mockTest, jobPostId)}
                    </span>
                  </div>
                  <div className="flex flex-col bg-gray-50 p-3 rounded-lg">
                    <span className="text-gray-500 text-sm mb-1">Answered</span>
                    <span className="text-primary font-medium">
                      {mockTest?.numberOfCorrect ||
                        jobPostId?.mockTest?.numberOfCorrect ||
                        "-"}
                    </span>
                  </div>
                  <div className="flex flex-col bg-gray-50 p-3 rounded-lg">
                    <span className="text-gray-500 text-sm mb-1">
                      Skipped questions
                    </span>
                    <span className="text-primary font-medium">
                      {mockTest?.numberOfUnanswered ||
                        jobPostId?.mockTest?.numberOfUnanswered ||
                        "-"}
                    </span>
                  </div>
                </div>
                {isMockApplicationOpen && (
                  <p className="mt-4 text-sm text-gray-500 bg-gray-50 p-3 rounded-lg">
                    {isMockApplicationOpen}
                  </p>
                )}
              </div>
            )}

            {jobPostId?.technicalInterview !== null && (
              <div className="border-b border-gray-100 pb-6">
                <div className="flex items-center justify-between mb-4">
                  <p className="text-lg font-semibold">Technical Interview</p>
                  <div className="flex flex-col items-end gap-2">
                    {jobPostId?.mockTest === null ? (
                      <button
                        onClick={() => {
                          const TechnicalInterviewDate = jobPostId?.openAt
                            ?.filter(
                              (item) => item.label === "technicalInterview",
                            )
                            .map((item) => item.time)[0];
                          if (
                            findDateIscurrentlyOrNot(TechnicalInterviewDate)
                          ) {
                            setisTechincalApplicationOpen(
                              convertDate(TechnicalInterviewDate),
                            );
                            return alert(convertDate(TechnicalInterviewDate));
                          }
                          if (!technicalInterview) {
                            navigateToInterview(
                              jobPostId?.technicalInterview?._id,
                              _id,
                            );
                          }
                          if (technicalInterview?.result?.length <= 0) {
                            navigate(
                              `/interview/?continue=${technicalInterview?._id}`,
                            );
                          }
                        }}
                        className={`inline-flex items-center justify-center px-5 py-2 rounded-lg text-sm font-medium transition-colors ${
                          technicalInterview?.result?.length > 0
                            ? "bg-green-600 text-white hover:bg-green-700"
                            : "bg-[#fed500] text-white hover:bg-[#e6c000]"
                        }`}
                      >
                        {!technicalInterview
                          ? "Take the Interview"
                          : technicalInterview?.result?.length > 0
                            ? "Interview Completed"
                            : "Continue Interview"}
                      </button>
                    ) : mockTest ? (
                      <button
                        onClick={() => {
                          const TechnicalInterviewDate = jobPostId?.openAt
                            ?.filter(
                              (item) => item.label === "technicalInterview",
                            )
                            .map((item) => item.time)[0];
                          if (
                            findDateIscurrentlyOrNot(TechnicalInterviewDate)
                          ) {
                            setisTechincalApplicationOpen(
                              convertDate(TechnicalInterviewDate),
                            );
                            return alert(convertDate(TechnicalInterviewDate));
                          }
                          if (!technicalInterview) {
                            navigateToInterview(
                              jobPostId?.technicalInterview?._id,
                              _id,
                            );
                          }
                          if (technicalInterview?.result?.length <= 0) {
                            navigate(
                              `/interview/?continue=${technicalInterview?._id}`,
                            );
                          }
                        }}
                        className={`inline-flex items-center justify-center px-5 py-2 rounded-lg text-sm font-medium transition-colors ${
                          technicalInterview?.result?.length > 0
                            ? "bg-green-600 text-white hover:bg-green-700"
                            : "bg-[#fed500] text-white hover:bg-[#e6c000]"
                        }`}
                      >
                        {!technicalInterview
                          ? "Take the Interview"
                          : technicalInterview?.result?.length > 0
                            ? "Interview Completed"
                            : "Continue Interview"}
                      </button>
                    ) : (
                      <button
                        className="inline-flex items-center justify-center px-5 py-2 rounded-lg text-sm font-medium bg-red-500 text-white hover:bg-red-600 transition-colors gap-2"
                        onClick={() => {
                          alert(
                            "Complete the Mock test first to attempt the technical interview",
                          );
                        }}
                      >
                        <CiLock /> Locked
                      </button>
                    )}
                    {technicalInterview?.result?.length > 0 && (
                      <button
                        className="text-sm text-primary hover:text-primary/80 font-medium"
                        onClick={() => {
                          navigate(
                            `/dashboard/report/${technicalInterview._id}`,
                          );
                        }}
                      >
                        Check Your Report
                      </button>
                    )}
                  </div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div className="flex flex-col bg-gray-50 p-3 rounded-lg">
                    <span className="text-gray-500 text-sm mb-1">
                      Total questions
                    </span>
                    <span className="text-primary font-medium">
                      {technicalInterview?.noOfQuestions ||
                        jobPostId?.technicalInterview?.noOfQuestions ||
                        "-"}
                    </span>
                  </div>
                  <div className="flex flex-col bg-gray-50 p-3 rounded-lg">
                    <span className="text-gray-500 text-sm mb-1">Answered</span>
                    <span className="text-primary font-medium">-</span>
                  </div>
                  <div className="flex flex-col bg-gray-50 p-3 rounded-lg">
                    <span className="text-gray-500 text-sm mb-1">
                      Skipped questions
                    </span>
                    <span className="text-primary font-medium">-</span>
                  </div>
                </div>
                {isTechincalApplicationOpen && (
                  <p className="mt-4 text-sm text-gray-500 bg-gray-50 p-3 rounded-lg">
                    {isTechincalApplicationOpen}
                  </p>
                )}
              </div>
            )}

            {jobPostId?.hrInterview !== null && (
              <div className="border-b border-gray-100 pb-6">
                <div className="flex items-center justify-between mb-2">
                  <p className="text-lg font-semibold">HR Interview</p>
                  <div className="flex flex-col items-end gap-2">
                    {jobPostId?.technicalInterview === null ? (
                      <button
                        onClick={() => {
                          const hrInterviewTime = jobPostId?.openAt
                            ?.filter((item) => item.label === "hrInterview")
                            .map((item) => item.time)[0];
                          if (findDateIscurrentlyOrNot(hrInterviewTime)) {
                            setisHRApplicationOpen(
                              convertDate(hrInterviewTime),
                            );
                            return alert(convertDate(hrInterviewTime));
                          }
                          if (!hrInterview) {
                            navigateToInterview(
                              jobPostId?.hrInterview?._id,
                              _id,
                            );
                          }
                          if (hrInterview?.result?.length <= 0) {
                            navigate(`/interview/?continue=${hrInterview._id}`);
                          }
                        }}
                        className={`inline-flex items-center justify-center px-5 py-2 rounded-lg text-sm font-medium transition-colors ${
                          hrInterview?.result?.length > 0
                            ? "bg-green-600 text-white hover:bg-green-700"
                            : "bg-[#fed500] text-white hover:bg-[#e6c000]"
                        }`}
                      >
                        {!hrInterview
                          ? "Take the Interview"
                          : hrInterview?.result?.length > 0
                            ? "Interview Completed"
                            : "Continue Interview"}
                      </button>
                    ) : technicalInterview?.result?.length > 0 ? (
                      <button
                        onClick={() => {
                          const hrInterviewTime = jobPostId?.openAt
                            ?.filter((item) => item.label === "hrInterview")
                            .map((item) => item.time)[0];
                          if (findDateIscurrentlyOrNot(hrInterviewTime)) {
                            setisHRApplicationOpen(
                              convertDate(hrInterviewTime),
                            );
                            return alert(convertDate(hrInterviewTime));
                          }
                          if (!hrInterview) {
                            navigateToInterview(
                              jobPostId?.hrInterview?._id,
                              _id,
                            );
                          }
                          if (hrInterview?.result?.length <= 0) {
                            navigate(`/interview/?continue=${hrInterview._id}`);
                          }
                        }}
                        className={`inline-flex items-center justify-center px-5 py-2 rounded-lg text-sm font-medium transition-colors ${
                          hrInterview?.result?.length > 0
                            ? "bg-green-600 text-white hover:bg-green-700"
                            : "bg-[#fed500] text-white hover:bg-[#e6c000]"
                        }`}
                      >
                        {!hrInterview
                          ? "Take the Interview"
                          : hrInterview?.result?.length > 0
                            ? "Interview Completed"
                            : "Continue Interview"}
                      </button>
                    ) : (
                      <div className="flex flex-col items-end gap-2">
                        <button
                          className="inline-flex items-center justify-center px-5 py-2 rounded-lg text-sm font-medium bg-red-500 text-white hover:bg-red-600 transition-colors gap-2"
                          onClick={() => setShowHRError(true)}
                        >
                          <CiLock /> Locked
                        </button>
                      </div>
                    )}
                    {hrInterview?.result?.length > 0 && (
                      <button
                        className="text-sm text-primary hover:text-primary/80 font-medium"
                        onClick={() => {
                          navigate(`/dashboard/report/${hrInterview._id}`);
                        }}
                      >
                        Check Your Report
                      </button>
                    )}
                  </div>
                </div>
                {showHRError && (
                  <p className="text-sm mb-2 text-red-500">
                    Complete the Technical Interview first to attempt the HR
                    interview
                  </p>
                )}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div className="flex flex-col bg-gray-50 p-3 rounded-lg">
                    <span className="text-gray-500 text-sm mb-1">
                      Total questions
                    </span>
                    <span className="text-primary font-medium">
                      {hrInterview?.noOfQuestions ||
                        jobPostId?.hrInterview?.noOfQuestions ||
                        "-"}
                    </span>
                  </div>
                  <div className="flex flex-col bg-gray-50 p-3 rounded-lg">
                    <span className="text-gray-500 text-sm mb-1">Answered</span>
                    <span className="text-primary font-medium">-</span>
                  </div>
                  <div className="flex flex-col bg-gray-50 p-3 rounded-lg">
                    <span className="text-gray-500 text-sm mb-1">
                      Skipped questions
                    </span>
                    <span className="text-primary font-medium">-</span>
                  </div>
                </div>
                {isHRApplicationOpen && (
                  <p className="mt-4 text-sm text-gray-500 bg-gray-50 p-3 rounded-lg">
                    {isHRApplicationOpen}
                  </p>
                )}
              </div>
            )}

            {jobPostId?.technicalInterview == null &&
              jobPostId?.hrInterview == null &&
              null}
          </div>
        </div>
      </div>
    );
  });
}

export function JobStatus(job) {
  // console.log("hello");
  console.log(job.job);
  const { CommonStore } = useStores();
  // const [interview, setInterview] = useState(false);
  const interview = () => {
    if (
      job.job.jobPostId?.technicalInterview === null &&
      job?.job.hrInterview !== undefined
    ) {
      return true;
      console.log(" in hr");
    } else if (
      job.job.jobPostId?.hrInterview === null &&
      job?.job.technicalInterview !== undefined
    ) {
      return true;
      console.log(" in tech");
    } else if (
      job?.job.technicalInterview !== undefined &&
      job?.job.hrInterview !== undefined
    ) {
      console.log("in useeffect iuhbv");

      return true;
    } else {
      console.log("in useeffect false");
      return false;
    }
  };

  useEffect(() => {
    if (job?.job?.isShortlisted) {
      CommonStore.ApplicationProgress[4].completed = true;
    } else {
      CommonStore.ApplicationProgress[4].completed = false;
    }
  }, [job?.job?.isShortlisted]);

  return useObserver(() => {
    return (
      <>
        {interview() && (
          <div className="w-[100%] flex items-center justify-center">
            {job?.job?.isShortlisted && (
              <span className="text-green-500 flex items-center gap-2">
                <AiOutlineCheck /> Your application has been shortlisted
              </span>
            )}
            {job?.job?.isRejected && (
              <span className="text-red-500 flex items-center gap-2">
                <AiOutlineClose /> Your application has been Rejected
              </span>
            )}
            {!job?.job?.isShortlisted && !job?.job?.isRejected && (
              <span className="text-green-500 flex items-center gap-2">
                <AiOutlineClockCircle /> Your application is under review
              </span>
            )}
          </div>
        )}
      </>
    );
  });
}

export default function JobPostPage() {
  const [selectedJob, setSelectedJob] = useState(null);
  const { CommonStore, RecuiterStore, PopupStore } = useStores();
  const [showResumeCard, setShowResumeCard] = useState(false);
  const [loading, setLoading] = useState(false);
  const fileInputRef = useRef(null);
  const [selectedResume, setSelectedResume] = useState(null);
  const [resume, setResume] = useState(null);

  const { id } = useParams(); // Get the dynamic ID from the URL
  // const [job, setJob] = useState({});
  const navigate = useNavigate();
  // const hasRun = useRef(false);.
  const fetchJob = async () => {
    try {
      const storedJobsString = localStorage.getItem("job");
      if (storedJobsString) {
        const storedJobs = JSON.parse(storedJobsString);
        // Ensure storedJobs is an array before filtering
        if (Array.isArray(storedJobs)) {
          const job = storedJobs.find((job) => job._id === id); // Use find if you're looking for a single job
          if (job) {
            setSelectedJob(job);
            console.log("job", job);
          } else {
            console.log("No job found with id:", id);
          }
        } else {
          console.error("Stored jobs is not an array");
        }
      } else {
        console.log("No job found in localStorage");
      }
    } catch (error) {
      console.error("Failed to fetch job from localStorage", error);
    }
  };
  useEffect(() => {
    // if (!hasRun.current) {
    fetchJob();
    // hasRun.current = true;
    // }
  }, [id]); // Depend on id instead of selectedJob to refetch when id changes
  const fetchData = async (pdfFile) => {
    try {
      const response = await axios.get(pdfFile, {
        responseType: "arraybuffer",
      });

      const pdfData = response.data; // Directly use response.data as array buffer

      const pdf = await pdfjs.getDocument({ data: pdfData }).promise;
      let fullText = "";

      for (let i = 1; i <= pdf.numPages; i++) {
        const page = await pdf.getPage(i);
        const content = await page.getTextContent();
        const pageText = content.items.map((item) => item.str).join("\n");
        fullText += pageText + "\n";
      }

      // setExtractedText(fullText);
      console.log(fullText);

      localStorage.setItem("resumeText", fullText);
      return fullText;
      // alert(true)
      // InterviewStore.setResumeText(fullText);
    } catch (error) {
      return "";
      console.error("Error fetching or parsing PDF file", error);
    }
  };
  const handleResumeText = (e) => {
    const selectedFile = e.target.files[0];

    if (selectedFile) {
      // InterviewStore.setResumeFile(selectedFile);
      const fileURL = URL.createObjectURL(selectedFile);
      const res = fetchData(fileURL);
      return res;
      // const { name } = selectedFile;
      // setSelectedFileName(name); // Update the state with the filename
      // setSelectFileByUser(selectedFile);
    }
  };

  const handleFileChange = async (e) => {
    console.log("handlefilechange");
    try {
      const res = handleResumeText(e);
      if (res.lenngth < 5) {
        alert("Please upload a valid resume");
        return;
      }
      const timestamp = Date.now().toString();
      const min = 1000;
      const max = 9999;
      const randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;
      const filename = randomNumber + timestamp;
      setSelectedResume(e.target.files[0]);
      console.log(selectedResume);
      setLoading(true);
      const fileUploaded = await uploadFileToAzure(
        filename,
        e.target.files[0],
        { action: "resume" },
      );

      const stringifiedURL = JSON.stringify(fileUploaded.url);
      localStorage.setItem("resume", stringifiedURL);
      setResume(fileUploaded.url);
      console.log(resume);
      console.log(fileUploaded.url);

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error uploading file:", error);
    }
  };
  const handleDelete = () => {
    setResume(null);
    setSelectedResume(null);
  };
  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };
  const handleDrop = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const file = event.dataTransfer.files[0];
    if (file) {
      fileInputRef.current.files = event.dataTransfer.files;
      handleFileChange({ target: fileInputRef.current });
    }
  };
  const handleApplyForJob = async () => {
    setLoading(true);
    const fileUploaded = await uploadFileToAzure(
      selectedResume.name,
      selectedResume,
      { action: "resume" },
    );
    if (fileUploaded.success) {
      await RecuiterStore.updateApplicantResume(id, fileUploaded.url);
    }
    fetchJob();
    setLoading(false);
    PopupStore.setShowResumeCard(false);
  };

  return useObserver(() => {
    return (
      <div className="flex flex-row bg-white  gil-reg   w-full ">
        {window.innerWidth > 999 && <HelpCenter />}
        <PopupForUploadResume
          popUpInitialValue={PopupStore.ShowResumeCard}
          handlePopup={() => {
            PopupStore.setShowResumeCard(false);
          }}
          reSubmit={true}
          content="Please upload your resume "
          buttontext="Upload Resume"
          onClick={handleFileChange}
          fileInputRef={fileInputRef}
          onDelete={handleDelete}
          onDragOver={handleDragOver}
          onDrop={handleDrop}
          resumeName={selectedResume?.name}
          selectFile={() => fileInputRef.current.click()}
          applyJob={handleApplyForJob}
          loading={loading}
        />
        {CommonStore.resume && (
          <PdfViewer
            AllowUsertoReSubmit={true}
            reSubmit={() => {
              PopupStore.setShowResumeCard(true);
            }}
            pdfUrl={CommonStore.jobresume}
            onClose={() => CommonStore.setResume(false)}
          />
        )}

        <div className="text-left h-screen overflow-hidden md:w-[30%] mx-auto w-[95%]">
          <JobList id={id} />
        </div>
        <div
          className={`bg-white hidden md:block mt-[1%] rounded-lg ${
            selectedJob ? "overflow-hidden" : "overflow-hidden"
          } w-[70%] mx-auto`}
        >
          {selectedJob ? (
            <JobPostReport job={selectedJob} />
          ) : (
            <div className={`w-full`}>
              {RecuiterStore.jobApplications.length === 0 ? (
                <div className="md:flex-col md:flex md:items-center md:justify-center md:mr-[50%] ">
                  <img src={OopsImage} alt="Oops" />
                  <button
                    className=" p-2 px-4 text-white rounded-lg bg-primary flex  justify-center items-center "
                    onClick={() => navigate("/dashboard/jobinternship")}
                  >
                    Apply for job
                  </button>
                </div>
              ) : (
                // <div className="h-screen flex justify-center items-center">

                //   {/* <AssessmentTutorial />
                //    */}
                // </div>
                <div className="text-right h-screen overflow-hidden md:w-[70%] mx-auto">
                  <h1 className="text-xl md:text-2xl lg:text-2xl  font-bold my-5 flex items-center justify-center h-screen overflow-hidden pb-[8rem]">
                    Select a Job to view details
                  </h1>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    );
  });
}
{
  /* <p className="font-semibold text-lg w-fit h-fit opacity-70">
                    Please select a job to view details.
                  </p> */
}

export function JobPostReport({ job }) {
  const { id } = useParams(); // Get the dynamic ID from the URL
  const [mobilejob, setMobileJob] = useState({});
  console.log(id, "id of job");

  useEffect(() => {
    const fetchJob = async () => {
      try {
        const storedJobsString = localStorage.getItem("job");
        if (storedJobsString) {
          const storedJobs = JSON.parse(storedJobsString);
          // Ensure storedJobs is an array before filtering
          if (Array.isArray(storedJobs)) {
            const job = storedJobs.find((job) => job?._id === id); // Use find if you're looking for a single job
            if (job) {
              setMobileJob(job);
              console.log("job", job);
            } else {
              console.log("No job found with id:", id);
            }
          } else {
            console.error("Stored jobs is not an array");
          }
        } else {
          console.log("No job found in localStorage");
        }
      } catch (error) {
        console.error("Failed to fetch job from localStorage", error);
      }
    };
    fetchJob();
  }, [id]);

  return useObserver(() => (
    <div className="gil-reg h-[98vh]">
      <HelpCenter />
      <JobPostDetails job={window.innerWidth < 999 ? mobilejob : job} />
      {/* <JobDetails job={window.innerWidth < 999 ? mobilejob : job} />
      <InterviewDetails job={window.innerWidth < 999 ? mobilejob : job} />
      <JobStatus job={window.innerWidth < 999 ? mobilejob : job} /> */}
    </div>
  ));
}

const JobCard = ({
  jobTitle,
  company,
  pic,
  job,
  createdAt,
  steps,
  onClick,
  selected,
}) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const oneWeekAgo = new Date(now.setDate(now.getDate() - 7));

    if (date > oneWeekAgo) {
      return formatDistanceToNow(date, { addSuffix: true });
    } else {
      return format(date, "MMMM dd, yyyy");
    }
  };

  // Example usage in JSX
  const dateString = job?.createdAt;

  const formattedDate = formatDate(dateString);
  return (
    <div
      className={`bg-white  px-6 py-4 rounded-xl my-5 w-full mb-2 md:max-w-md cursor-pointer ${
        !selected ? "border border-white " : "border border-primary"
      }`}
      style={{
        boxShadow: !selected ? "0px 10px 60px 0px rgba(0,0,0,0.1)" : "",
      }}
    >
      <div className="flex items-center space-x-4">
        <img
          src={pic || defaultProfilePic}
          alt="Company Logo"
          className="md:w-[85.74px] lg:w-[85.74px] md:h-[90px] lg:h-[90px] w-[70px] h-[70px] object-cover rounded p-2 "
        />
        <div>
          <div className="flex flex-row items-start md:items-center gap-2 md:gap-7">
            <h2 className="md:text-base lg:text-lg text-xs mt-2 font-bold whitespace-nowrap ">
              {jobTitle}
            </h2>
            {/* <div className="flex items-center md:text-sm lg:text-sm text-xs gap-1 mt-2 ">
              <LuDot className="text-green-500" />
              <span className="text-green-500 ">Active</span>
            </div> */}
          </div>
          <p className="text-gray-400 md:text-sm lg:text-sm text-xs py-2 ">
            {company}
          </p>
          <div className="flex items-center gap-1">
            <GoClock className="text-slate-400" />
            <p className="text-gray-500 md:text-xs lg:text-xs text-[10px] whitespace-nowrap ">
              Applied On : <span className=" text-black">{formattedDate} </span>
            </p>
          </div>
        </div>
      </div>
      <div className="flex flex-row md:text-xs md:-ml-1 lg:text-xs text-[9px] items-center   lg:space-x-4 gap-1 space-x-1 mt-4">
        {steps.map((step, index) => (
          <div key={index} className={`text-xxs flex items-center gap-1`}>
            <RiCheckboxCircleLine
              className={`text-base ${
                step.value ? "text-primary" : "text-[#808080]"
              }`}
            />
            <span
              className={`whitespace-nowrap ${
                step.value ? "text-black" : "text-[#808080]"
              }`}
            >
              {step.name}
            </span>
          </div>
        ))}
      </div>
      <div className="mt-4 flex  md:flex-row justify-between items-center">
        <button
          className="bg-orange-500 text-white flex items-center gap-1 md:py-2 lg:py-2 py-2 px-2 rounded-md md:text-xs lg:text-xs text-[10px]"
          onClick={onClick}
        >
          {steps[3].value ? "View Details" : "Complete Assessment"}
          <LiaChevronCircleRightSolid className="text-sm" />
        </button>
        <span className="md:text-xs lg:text-xs text-[10px] mt-1  md:mt-0 pr-0 md:pr-6">
          Status:{" "}
          <span
            className={` ${
              job?.status === 0
                ? "bg-yellow"
                : job?.status === 1
                  ? "text-blue-500"
                  : job?.status === 2
                    ? "text-red-500"
                    : job?.status === 3
                      ? "text-green-500"
                      : "text-gray-500"
            }`}
          >
            {job?.status === 0
              ? "Pending"
              : job?.status === 1
                ? "Shortlisted"
                : job?.status === 2
                  ? "Rejected"
                  : job?.status === 3
                    ? "Hired"
                    : ""}
          </span>
        </span>
      </div>
    </div>
  );
};

export function JobList({ id, from, onJobSelect }) {
  // const { id } = useParams(); // Get the dynamic ID from the URL
  const [jobData, setJobData] = useState([]);
  // const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { CommonStore, RecuiterStore } = useStores();
  const [selectedId, setSelectedId] = useState(id);
  // const userDetails = JSON.parse(localStorage.getItem("user"));
  // const userId = userDetails?._id;
  const navigate = useNavigate();
  // const [load, setload] = useState(false);

  const applicationsPerPage = 4;
  const [page, setPage] = useState(0);
  const [refresh, setRefresh] = useState(0);
  const [previousRefresh, setPreviousRefresh] = useState(0);

  useEffect(() => {
    const skip = page * applicationsPerPage; // Calculate skip dynamically
    const limit = applicationsPerPage;

    if (
      RecuiterStore.jobApplications.length === 0 ||
      previousRefresh !== refresh
    ) {
      const body = {
        skip,
        limit,
      };

      RecuiterStore.fetchJobApplications(body);
      console.log(
        "pageCount",
        Math.ceil(RecuiterStore.applicationCount / applicationsPerPage),
      );
      setPreviousRefresh(refresh);
    }
  }, [refresh, page]);

  if (error) {
    return <div>{error}</div>;
  }

  const navigation = (id) => {
    setSelectedId(id);
    if (window.innerWidth < 999) {
      return navigate(`/newone/${id}`);
    }
    return navigate(`/dashboard/myapplicants/${id}`);
  };
  const handlePageClick = (event) => {
    // setSkip(page.selected * limit);
    // fetchJobData(page.selected * limit);
    setPage(event.selected);
    const skip = event.selected * applicationsPerPage;
    const body = {
      skip: skip,
      limit: applicationsPerPage,
    };
    RecuiterStore.fetchJobApplications(body);
    console.log(event.selected);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const oneWeekAgo = new Date(now.setDate(now.getDate() - 7));

    if (date > oneWeekAgo) {
      return formatDistanceToNow(date, { addSuffix: true });
    } else {
      return format(date, "MMM dd");
    }
  };

  return (
    <Observer>
      {() => (
        <>
          {/* <div
            onClick={() => {
              setPage(0);
              setRefresh(refresh + 1);
            }}
            className=" mt-16 md:mt-0 z-50 p-2 md:top-[25px] lg:top-[25px] cursor-pointer bg-white top-10 rounded-lg gap-2 px-3 md:relative lg:relative absolute inset-0 text-primary font-bold flex justify-center items-center !h-fit w-fit left-5 mr-5 "
          >
            <p>Refresh</p>
            <LuRefreshCcw />
          </div> */}
          <div
            className={
              from === "lables"
                ? "flex flex-col md:p-10 lg:p-10 justify-between w-full md:h-[90vh]  h-[98vh] md:overflow-auto   relative "
                : "flex flex-col mt-6 md:mt-5 justify-start gamd:p-10 lg:p-10 w-full md:h-[105vh]  h-[98vh]  md:overflow-auto over relative pb-[1rem]"
            }
          >
            <Loader loader={RecuiterStore.loader} />
            <h1 className="flex text-3xl mx-4 mb-2 font-bold text-primary">
              My Jobs
            </h1>
            <div className=" items-center justify-between pr-2 rounded-lg border-primary border  mx-4 hidden md:flex lg:flex  ">
              <input
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    const body = {
                      search: e.target.value,
                    };
                    // alert(e.target.value);
                    RecuiterStore.fetchJobApplications(body);
                  }
                }}
                type="text"
                placeholder="Search your jobs"
                className="w-full py-2 pl-4 pr-10 text-sm outline-none text-gray-600 rounded-lg"
                // onChange={handleInputChange}
              />
              <IoSearchOutline className="text-primary" />
            </div>
            <div
              className={
                from === "labels"
                  ? `my-14 md:my-0 md:w-full md:mx-auto flex  lg:p-10 flex-col md:flex-row lg:flex-row overflow-y-auto no-scrollbar  md:overflow-y-auto bg-white md:p-4`
                  : " md:mt-0  md:my-0 md:w-full md:mx-auto overflow-scroll h-screen md:overflow-y-auto no-scrollbar md:bg-white lg:bg-white  md:pb-0 lg:pb-0  md:p-4"
              }
              style={{ scrollbarWidth: "0", msOverflowStyle: "none" }}
            >
              <div className="md:hidden lg:hidden block">
                <h1 className="flex text-xl mx-4  font-bold text-primary">
                  My Jobs
                </h1>
                <div className=" items-center justify-between pr-2 rounded-lg border-primary border  mx-2 block flex md:flex lg:flex  ">
                  <input
                    onKeyPress={(e) => {
                      if (e.key === "Enter") {
                        const body = {
                          search: e.target.value,
                        };
                        // alert(e.target.value);
                        RecuiterStore.fetchJobApplications(body);
                      }
                    }}
                    type="text"
                    placeholder="Search you jobs"
                    className="w-full py-2 pl-4 pr-10 text-sm outline-none text-gray-600 rounded-lg"
                    // onChange={handleInputChange}
                  />
                  <IoSearchOutline className="text-primary" />
                </div>
              </div>
              <div className="flex flex-col gap-2">
                {RecuiterStore.jobApplications.map((job, index) => {
                  const formattedDate = formatDate(job?.createdAt);
                  const steps = [
                    { name: "Applied", value: true },
                    { name: "MCQ's", value: job?.mockTest ? true : false },
                    {
                      name: "Technical Interview",
                      value: job?.technicalInterview ? true : false,
                    },
                    {
                      name: "HR Interview",
                      value: job?.hrInterview ? true : false,
                    },
                  ];
                  return (
                    <div
                      key={index}
                      className="bg-white shadow-xl p-6 rounded-xl cursor-pointer hover:shadow-2xl transition-shadow"
                      style={{
                        boxShadow: "0px 10px 30px 0px rgba(0, 0, 0, 0.2)",
                      }}
                      onClick={() => navigation(job?._id)}
                    >
                      <div className="flex items-start space-x-4">
                        <img
                          src={
                            job?.recruiter?.pic ||
                            "https://img.freepik.com/premium-vector/building-logo-icon-design-template-vector_67715-555.jpg"
                          }
                          alt="Company Logo"
                          className="w-16 h-16 md:w-20 md:h-20 object-cover rounded-lg"
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src =
                              "https://img.freepik.com/ gap-2m-vector/building-logo-icon-design-template-vector_67715-555.jpg";
                          }}
                        />
                        <div className="flex-1">
                          <div className="flex flex-col md:flex-row md:items-center gap-2">
                            <h2 className="text-sm md:text-base font-bold line-clamp-1">
                              {job?.jobPostId?.jobTitle}
                            </h2>
                            <div className="flex items-center text-xs gap-1">
                              <LuDot className="text-[#20BF55]" />
                              <span className="text-[#20BF55]">Active</span>
                            </div>
                          </div>
                          <p className="text-gray-500 text-xs md:text-sm py-1 line-clamp-1">
                            {job?.recruiter?.companyName}
                          </p>
                          <div className="flex flex-wrap gap-3 mt-1">
                            <div className="flex items-center gap-1 text-xs text-gray-500">
                              <MdLocationOn className="text-base" />
                              <span className="line-clamp-1">
                                {job?.jobPostId?.jobLocation || "Remote"}
                              </span>
                            </div>
                            <div className="flex items-center gap-1 text-xs text-gray-500">
                              <span className="line-clamp-1">
                                {job?.jobPostId?.salary?.minimum &&
                                job?.jobPostId?.salary?.maximum ? (
                                  <>
                                    ̰ ₹{" "}
                                    {job?.jobPostId?.salary?.minimum >= 100000
                                      ? `${
                                          job?.jobPostId?.salary?.minimum /
                                          100000
                                        }L`
                                      : job?.jobPostId?.salary?.minimum}{" "}
                                    - ₹{" "}
                                    {job?.jobPostId?.salary?.maximum >= 100000
                                      ? `${
                                          job?.jobPostId?.salary?.maximum /
                                          100000
                                        }L`
                                      : job?.jobPostId?.salary?.maximum}{" "}
                                  </>
                                ) : (
                                  <p> ₹ Not Disclosed </p>
                                )}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="grid grid-cols-2 md:grid-cols-4 gap-2 mt-4">
                        {steps.map((step, index) => (
                          <div
                            key={index}
                            className="flex items-center gap-1 text-xs min-w-0"
                          >
                            <RiCheckboxCircleLine
                              className={`text-base flex-shrink-0 ${
                                step.value ? "text-primary" : "text-[#808080]"
                              }`}
                            />
                            <span
                              className={`truncate ${
                                step.value ? "text-black" : "text-[#808080]"
                              }`}
                            >
                              {step.name}
                            </span>
                          </div>
                        ))}
                      </div>
                      <div className="mt-4 flex flex-row justify-between items-center gap-2">
                        <span
                          className={`px-2 py-1 rounded-full text-xs font-medium flex items-center gap-1 ${
                            job?.status === 0
                              ? "bg-amber-100 text-amber-700"
                              : job?.status === 1
                                ? "bg-blue-100 text-blue-700"
                                : job?.status === 2
                                  ? "bg-red-100 text-red-700"
                                  : job?.status === 3
                                    ? "bg-green-100 text-green-700"
                                    : "bg-gray-100 text-gray-700"
                          }`}
                        >
                          {job?.status === 0 ? (
                            <>
                              <MdPendingActions className="text-base" />
                              Pending
                            </>
                          ) : job?.status === 1 ? (
                            <>
                              <FaUserCheck className="text-base" />
                              Shortlisted
                            </>
                          ) : job?.status === 2 ? (
                            <>
                              <IoMdCloseCircle className="text-base" />
                              Rejected
                            </>
                          ) : job?.status === 3 ? (
                            <>
                              <BsCheckCircleFill className="text-base" />
                              Hired
                            </>
                          ) : null}
                        </span>
                        <div className="flex items-center gap-1 text-xs">
                          <GoClock className="text-slate-400" />
                          <p className="text-gray-500">
                            <span className="text-black">{formattedDate}</span>
                          </p>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            {RecuiterStore.jobApplications.length !== 0 &&
            RecuiterStore.applicationCount > applicationsPerPage ? (
              <ReactPaginate
                nextLabel=" >"
                className="flex justify-center items-center gap-5 my-4 mb-[4rem]"
                onPageChange={handlePageClick}
                forcePage={page}
                pageRangeDisplayed={3}
                marginPagesDisplayed={2}
                pageCount={Math.ceil(
                  RecuiterStore.applicationCount / applicationsPerPage,
                )}
                previousLabel="< "
                pageClassName="page-item"
                pageLinkClassName="page-link"
                previousClassName="page-item"
                previousLinkClassName="page-link"
                nextClassName="page-item"
                nextLinkClassName="page-link"
                breakLabel="..."
                breakClassName="page-item"
                breakLinkClassName="page-link"
                containerClassName="pagination"
                activeClassName="active-page-item"
                activeLinkClassName="active-page-link"
                renderOnZeroPageCount={null}
              />
            ) : null}
          </div>
        </>
      )}
    </Observer>
  );
}

const calculateTotalQuestions = (mockTest, jobPostId) => {
  if (mockTest) {
    return (
      (mockTest.numberOfCorrect || 0) +
      (mockTest.numberOfUnanswered || 0) +
      (mockTest.numberOfIncorrect || 0)
    );
  }

  if (jobPostId?.mockTest) {
    return (
      (Number(jobPostId.mockTest.noOfAptitudeQuestions) || 0) +
      (Number(jobPostId.mockTest.noOfReasoningQuestions) || 0) +
      (Number(jobPostId.mockTest.noOfVerbalQuestions) || 0) +
      (Number(jobPostId.mockTest.noOfTechnicalQuestions) || 0)
    );
  }

  return 0;
};
